import React, { useContext } from 'react';

import * as S from './styles';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataFormProps } from 'types/InputsStoriesCarouselProps';
import TypeStoreContext from 'context/TypeStoreContext';
import Default from './interfaces/Default';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import Fashion from './interfaces/Fashion';
// import Grocery from './interfaces/Grocery';

interface StoriesCarouselProps {
	item: ItemDynamicPageInPhone;
}

export default function StoriesCarousel({ item }: StoriesCarouselProps) {
	const { data } = item;
	const { typeStore } = useContext(TypeStoreContext);

	const storiesData: DataFormProps = data;

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <Default storiesData={storiesData} />;

			case 'grocery':
				return <Default storiesData={storiesData} />;

			case 'fashion':
				return <Fashion storiesData={storiesData} />;

			default:
				return <Default storiesData={storiesData} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{storiesData.schedule !== undefined &&
				(storiesData?.schedule?.start !== '' ||
					storiesData?.schedule?.end !== '') && (
					<ScheduleInfoDynamicPage
						countdown={storiesData?.schedule?.countdown}
						endDate={storiesData?.schedule?.end}
						startDate={storiesData?.schedule?.start}
					/>
				)}

			{returnInterfaceByTypeStore()}
		</S.container>
	);
}
